import { API } from 'aws-amplify';
import { CHECK_USER_EXISTENCE, GET_USER_BY_ID } from 'src/graphql/users/queries';
import client from 'src/utils/apolloClient';

const catchError = (e) => {
  if (e.response) {
    return e.response.data.message;
  }
  return e.message;
};

export const createUser = (data) => {
  return API.post('api', '/users', {
    body: data,
  }).catch((e) => {
    const error = catchError(e);
    throw new Error(error);
  });
};

export const updateUser = (id, data) => {
  return API.put('api', `/users/${id}`, {
    body: data,
  }).catch((e) => {
    const error = catchError(e);
    throw new Error(error);
  });
};

export const doesUserExist = async (email) => {
  const response = await client.query({ query: CHECK_USER_EXISTENCE, variables: { email: email } });

  if (response.data?.ri_apps_prd_users?.length > 0) {
    return response.data?.ri_apps_prd_users[0].user_id;
  } else {
    return null;
  }
};

export const getUserByID = async (id) => {
  const response = await client.query({ query: GET_USER_BY_ID, variables: { user_id: id } });

  return response.data?.row;
};
